import { ApplicationNames } from './shared';
import envConfig from '../config/config';

export const progeny2Application = {
  name: ApplicationNames.PROGENY2,
  url: envConfig.apps.progeny2,
  roles: ['sundial-role:PROGENY2_USER', 'sundial-role:PROGENY2_ADMIN'],
};
